module.exports = {"name":"issue","menu":{"items":[{"label":"Entrada","route":"/mensagens","weight":1,"cssClass":"messages"},{"label":"Respondidas","route":"/mensagens-respondidas","weight":2,"cssClass":"answered-messages"},{"label":"Lixeira","route":"/lixeira","weight":3,"cssClass":"deleted-messages"}],"parent":"menuMessages","weight":6}}


//////////////////
// WEBPACK FOOTER
// ./_source/javascripts/modules/issue/config.json
// module id = 389
// module chunks = 0